import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { InlineItemImpl } from "./inline.styles.es.js";
const propTypes = {
  children: PropTypes.node,
  ellipsify: PropTypes.bool,
  sizing: PropTypes.oneOf(["fill-container", "fit-content"])
};
const defaultProps = {
  children: void 0,
  ellipsify: false,
  sizing: "fit-content"
};
const InlineItem = ({ children, ellipsify, sizing }) => /* @__PURE__ */ jsx(InlineItemImpl, { $ellipsify: ellipsify, $sizing: sizing, children });
InlineItem.propTypes = propTypes;
InlineItem.defaultProps = defaultProps;
export {
  InlineItem
};
